import * as THREE from "three";

export function initInteractions(camera, scene, renderer) {
  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();
  const tooltip = document.getElementById("object-tooltip");
  
  let hoveredObject = null;
  const originalColors = new Map();

  function onMouseMove(event) {
    // Update mouse position
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    // Update tooltip position
    if (tooltip) {
      tooltip.style.left = `${event.clientX}px`;
      tooltip.style.top = `${event.clientY}px`;
    }

    // Raycast
    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(scene.children, true);

    let foundInteractive = null;

    if (intersects.length > 0) {
      // Find the first interactive ancestor
      for (const intersect of intersects) {
        let obj = intersect.object;
        while (obj) {
          if (obj.userData && obj.userData.interactive) {
            foundInteractive = obj;
            break;
          }
          obj = obj.parent;
        }
        if (foundInteractive) break;
      }
    }

    if (foundInteractive) {
      if (hoveredObject !== foundInteractive) {
        // Reset old hover
        if (hoveredObject) resetHover(hoveredObject);

        // Set experimental hover
        hoveredObject = foundInteractive;
        applyHover(hoveredObject);

        // Show tooltip
        if (tooltip) {
          tooltip.innerText = hoveredObject.userData.tooltipText || "Object";
          tooltip.style.display = "block";
        }
        document.body.style.cursor = "pointer";
      }
    } else {
      if (hoveredObject) {
        resetHover(hoveredObject);
        hoveredObject = null;
        if (tooltip) tooltip.style.display = "none";
        document.body.style.cursor = "default";
      }
    }
  }

  function applyHover(model) {
    model.traverse((child) => {
      if (child.isMesh && child.material && child.material.emissive) {
        // Store original emissive if not stored
        if (!originalColors.has(child.uuid)) {
            originalColors.set(child.uuid, child.material.emissive.clone());
        }
        // Highlight
        child.material.emissive.setHex(0x111111);
        child.material.emissiveIntensity = 0.5;
      }
    });
  }

  function resetHover(model) {
    model.traverse((child) => {
      if (child.isMesh && child.material && child.material.emissive) {
        const original = originalColors.get(child.uuid);
        if (original) {
          child.material.emissive.copy(original);
        } else {
          child.material.emissive.setHex(0x000000);
        }
      }
    });
  }

  function onClick(event) {
    if (hoveredObject && hoveredObject.userData && hoveredObject.userData.isMeme) {
      const memeModal = document.getElementById("meme-modal");
      const memeImg = document.getElementById("meme-img");
      if (memeModal && memeImg) {
        memeImg.src = hoveredObject.userData.imageUrl;
        memeModal.style.display = "block";
      }
    }
  }

  const memeClose = document.getElementById("meme-close");
  if (memeClose) {
    memeClose.onclick = function() {
      const memeModal = document.getElementById("meme-modal");
      if (memeModal) memeModal.style.display = "none";
    };
  }

  // Close modal when clicking outside the image
  window.addEventListener("click", function(event) {
    const memeModal = document.getElementById("meme-modal");
    if (event.target == memeModal) {
      memeModal.style.display = "none";
    }
  });

  window.addEventListener("mousemove", onMouseMove);
  window.addEventListener("click", onClick);
}
